import './App.css';

import EphraimHicksSite from './ephraim-hicks-music'
export default function App() {
  return <EphraimHicksSite />
}
